module.exports = __webpack_public_path__ + "img/img5_2.e8ec062f.jpeg";